
/* injects from baggage-loader */
require('./style.scss');

import React, { Component } from "react";
import GameListAsian from "../gameListAsian";
import GameList from "../gameList";
import PropTypes from "prop-types";

class GameListWrapper extends Component {
    render () {
        let { isAsian, gameType, sportAlias, regionId, competitionId, timeFilter, boostedOddsGameIds } = this.props;
        return (
            isAsian ? (<GameListAsian gameType={gameType}
                sportAlias={sportAlias}
                regionId={regionId}
                competitionId={competitionId}
                timeFilter={timeFilter}
                boostedOddsGameIds={boostedOddsGameIds}
                key={regionId + competitionId + sportAlias + timeFilter}
            />)
                : (<GameList gameType={gameType}
                    sportAlias={sportAlias}
                    regionId={regionId}
                    competitionId={competitionId}
                    timeFilter={timeFilter}
                    key={regionId + competitionId + sportAlias + timeFilter}
                    boostedOddsGameIds={boostedOddsGameIds}
                />)
        );
    }
}

GameListWrapper.propTypes = {
    isAsian: PropTypes.bool,
    gameType: PropTypes.string,
    sportAlias: PropTypes.any,
    regionId: PropTypes.any,
    competitionId: PropTypes.any,
    timeFilter: PropTypes.any,
    isGameComponentOpen: PropTypes.bool,
    gameId: PropTypes.number
};
export default GameListWrapper;
